import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts, deleteProduct, getProductByCategory, searchProducts } from "../../redux/productSlice";
import { addToCart } from "../../redux/cartSlice";
import { Spinner, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import { useLocation, useParams } from "react-router-dom";

const HOCProducts = (WrappedComponent) => {
  const HOC = (props) => {

    const dispatch = useDispatch();
    const { products, loading, error, page, pages, total } = useSelector((state) => state.products);

    const [allProducts, setAllProducts] = useState([]);
    const [toys, setToys] = useState([]);
    const [jewellery, setJewellery] = useState([]);
    const [bestSeller, setBestSeller] = useState([]);
    const [category, setCategory] = useState([]);
    const [allSearchProducts, setAllSearchProducts] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const [keywords, setKeywords] = useState({
      keyword: "",
      page: 1,
      limit: 10,
    });
    if (process.env.NODE_ENV === 'development') {
      console.log("keywords", keywords);
      console.log("allSearchProducts HOC", allSearchProducts);
    }



    const location = useLocation();
    const { category: categoryParam } = useParams();

    const searchQueryHandler = (query) => {
      setSearchQuery(query);
    }

    const handlePagination = (updated) => {
      setKeywords(updated); // updated should be the full object
    };

    const fetchProductsByCategory = async (category, params) => {
      try {
        const result = await dispatch(fetchProducts({ ...params, category })).unwrap();
        const categoryProducts = result.products || [];
        switch (category) {
          case "Jewellery":
            setJewellery(categoryProducts);
            break;
          case "Toys":
            setToys(categoryProducts);
            break;
          case "BestSeller":
            setBestSeller(categoryProducts);
            break;
          default:
            setAllProducts(categoryProducts); // fallback: treat as all products
            break;
        }
      } catch (err) {
        console.error(`Error fetching products for category "${category}":`, err);
      }
    };

    const searchDataProducts = async (params) => {
      try {
        const allSearchResult = await dispatch(searchProducts(params)).unwrap();
        setAllSearchProducts(allSearchResult.products);
      } catch (err) {
        toast.error("Search fetch error:", err);
      }
    };

    const fetchAllData = async (params) => {
      try {
        const allProductResult = await dispatch(fetchProducts(params)).unwrap();
        setAllProducts(allProductResult.products);
      } catch (err) {
        toast.error("Products fetch error:", err);
      }
    };

    const fetchProductsByRating = async (minRating, params) => {
      try {
        const allProductResult = await dispatch(fetchProducts({ ...params, minRating })).unwrap();
        setBestSeller(allProductResult.products);
      } catch (err) {
        toast.error("Product by Ratinng fetch error:", err);
      }
    }
    useEffect(() => {
      const pathname = location.pathname;
      let selectedCategory = "";
      let selectedRating = "";

      if (pathname.startsWith("/jewellery")) selectedCategory = "Jewellery";
      else if (pathname.startsWith("/toys")) selectedCategory = "Toys";
      else if (pathname.startsWith("/best-seller")) selectedRating = "minRating";
      else if (pathname.startsWith("/category/")) selectedCategory = categoryParam;
      else if (pathname === "/" || pathname.startsWith("/products")) selectedCategory = ""; // fetch all

      if (pathname === "/search") {
        // fetch search products
        searchDataProducts({ keyword: searchQuery, page: keywords.page, limit: keywords.limit });
      } else if (selectedCategory) {
        // fetch by category
        fetchProductsByCategory(selectedCategory, { page: keywords.page, limit: keywords.limit });
      } else if (selectedRating) {
        // fetch by rating
        fetchProductsByRating(2, { page: keywords.page, limit: keywords.limit });
      }

      else {
        // fetch all products
        fetchAllData({ page: keywords.page, limit: keywords.limit });
      }
    }, [location.pathname, searchQuery, keywords.page, keywords.limit, categoryParam]);



    const handleDelete = useCallback(async (id) => {
      try {
        await dispatch(deleteProduct(id));
        toast.success("Product deleted successfully.");
      } catch {
        toast.error("Failed to delete product.");
      }
    }, [dispatch]);

    const handleAddToCart = useCallback(async (product) => {
      try {
        await dispatch(addToCart({ items: [{ product: product, quantity: 1 }] }));
        toast.success(`${product.name} added to cart successfully!`);
      } catch {
        toast.error(`Failed to add ${product.name} to cart.`);
      }
    }, [dispatch]);

    if (loading) return <Spinner animation="border" className="mx-auto my-4 d-block" />;
    if (error) return <Alert variant="danger">{error}</Alert>;

    return (
      <WrappedComponent
        {...props}
        products={products}
        loading={loading}
        error={error}
        page={page}
        pages={pages}
        total={total}
        jewellery={jewellery}
        toys={toys}
        bestSeller={bestSeller}
        categoryData={category}
        allSearchProducts={allSearchProducts}

        handleDelete={handleDelete}
        handleAddToCart={handleAddToCart}
        keywords={keywords}
        handlePagination={handlePagination}
        allProducts={allProducts}
        searchQueryHandler={searchQueryHandler}
      />
    );
  };

  return HOC;
};

export default HOCProducts;
